import type { FC } from "react";
import { usePortfolioRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { PortfolioPageLegacy } from "web_myplann/Portfolio/Pages/PortfolioPageLegacy";
import { PortfolioPageRedesign } from "web_myplann/Portfolio/Pages/PortfolioPageRedesign";
import { MyPlannLoading } from "web_myplann/Shared/Components/MyPlannLoading";

export const PortfolioPage: FC = () => {
	const { hasRight: hasPortfolioRight, isPending } =
		usePortfolioRightOptional();

	if (isPending) {
		return <MyPlannLoading />;
	}

	return hasPortfolioRight ? (
		<PortfolioPageRedesign hasPortfolioRight />
	) : (
		<PortfolioPageLegacy />
	);
};
